import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "purchaseWarehouseSelector", "purchaseSummary", "allPurchaseSummary" ]

  connect() {
    this.filterPurchaseSummaries();
  }

  filterPurchaseSummaries() {
    const selectedWarehouseId = this.purchaseWarehouseSelectorTarget.value;

    // Hide all summaries initially
    this.purchaseSummaryTargets.forEach((summary) => summary.style.display = "none");
    if (this.hasAllPurchaseSummaryTarget) {
      this.allPurchaseSummaryTarget.style.display = "none";
    }

    if (selectedWarehouseId === "all") {
      if (this.hasAllPurchaseSummaryTarget) {
        this.allPurchaseSummaryTarget.style.display = "block";
      }
    } else if (selectedWarehouseId) {
      const summary = this.purchaseSummaryTargets.find(
          s => s.dataset.warehouseId === selectedWarehouseId
      );
      if (summary) summary.style.display = "block";
    }
    // If selectedWarehouseId is empty, all summaries remain hidden
  }
}
